import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true, name: "IFrameModalModule" })
export default class IFrameModalModule extends VuexModule {
  titleString = "";
  urlString = "";
  showIFrameBoolean = false;
  callback = null as null | Function;

  get callbackFunction() {
    return this.callback;
  }

  get title() {
    return this.titleString;
  }

  get url() {
    return this.urlString;
  }

  get showIframe() {
    return this.showIFrameBoolean;
  }

  @Mutation
  showModal({
    title,
    url,
    callback
  }: {
    title: string;
    url: string;
    callback: null | Function;
  }) {
    this.titleString = title ? title : "";
    this.urlString = url;
    this.callback = callback;
    this.showIFrameBoolean = true;
  }

  @Mutation
  hideModal() {
    this.titleString = "";
    this.urlString = "";
    this.showIFrameBoolean = false;
  }

  @Mutation
  setTitleString(titleString: string) {
    this.titleString = titleString;
  }

  @Mutation
  setUrlString(urlString: string) {
    this.urlString = urlString;
  }

  @Mutation
  setShowIFrameBoolean(showIFrameBoolean: boolean) {
    this.showIFrameBoolean = showIFrameBoolean;
  }
}
